// extracted by mini-css-extract-plugin
module.exports = {"FeedBack":"Feedback_style_FeedBack__2TWI-","cont":"Feedback_style_cont__kF9Jg","line":"Feedback_style_line__2vlT-","areaBtn":"Feedback_style_areaBtn__33Aou"};